<div *ngIf="isVisible" class="menu-element-container" [class]="field.panelClass">
    <button
        mat-icon-button
        type="button"
        [matTooltip]="field.tooltip | translate"
        (click)="toggleMenu($event)"
        class="menu-trigger"
        [disabled]="isDisabled$ | async"
    >
        <mat-icon *ngIf="field.iconName">{{ field.iconName }}</mat-icon>
        <span *ngIf="field.label" class="menu-label">{{ field.label | translate }}</span>
        <span *ngIf="field.menuIcon && !field.iconName" class="menu-icon">
            <mat-icon>{{ field.menuIcon }}</mat-icon>
        </span>
    </button>

    <div class="menu-dropdown" *ngIf="isMenuOpen" (clickOutside)="closeMenu()">
        <div class="menu-label" *ngIf="field.menuLabel">{{ field.menuLabel | translate }}</div>

        <div class="menu-items">
            <ng-container *ngFor="let menuItem of field.menuItems">
                <!-- UI Element Menu Items -->
                <ng-container *ngIf="menuItem.type === FieldType.UI">
                    <div *ngIf="menuItem.uiType === UIElementType.Button" class="menu-item">
                        <app-button-element [field]="menuItem" [isReadOnly]="isReadOnly"></app-button-element>
                    </div>

                    <div *ngIf="menuItem.uiType === UIElementType.Icon" class="menu-item">
                        <app-icon-element [field]="menuItem" [isReadOnly]="isReadOnly"></app-icon-element>
                    </div>

                    <div *ngIf="menuItem.uiType === UIElementType.Image" class="menu-item">
                        <app-image-element [field]="menuItem" [isReadOnly]="isReadOnly"></app-image-element>
                    </div>

                    <div *ngIf="menuItem.uiType === UIElementType.Text" class="menu-item">
                        <app-text-element [field]="menuItem"></app-text-element>
                    </div>

                    <div *ngIf="menuItem.uiType === UIElementType.Divider" class="menu-item">
                        <app-divider-element [field]="menuItem" [isReadOnly]="isReadOnly"></app-divider-element>
                    </div>
                </ng-container>

                <!-- Form Field Menu Items -->
                <ng-container *ngIf="menuItem.type !== FieldType.UI && menuItem.type !== FieldType.Section">
                    <div class="field-menu-item">
                        <app-field-renderer
                            [field]="menuItem"
                            [control]="getControlForMenuItem(menuItem)"
                            [isReadOnly]="isReadOnly"
                        >
                        </app-field-renderer>
                    </div>
                </ng-container>

                <!-- Section Menu Items -->
                <ng-container *ngIf="menuItem.type === FieldType.Section">
                    <div class="section-menu-item">
                        <app-section-renderer
                            [section]="menuItem.section"
                            [control]="control.get(menuItem.id)"
                            [isReadOnly]="isReadOnly"
                        >
                        </app-section-renderer>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </div>
</div>
